var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project && _vm.me)?_c('b-badge',{staticClass:"badge",class:_vm.label},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.label))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }